import React from "react";

import ToolbarButton from "./ToolbarButton";
import ToolbarText from "./ToolbarText";

import RenderOrientations, {
    RenderOrientationFlow,
} from "../../types/enums/RenderOrientation";
import { Side, Size } from "../../types/system/Layout";

import "./Toolbar.scss";
import Utilities from "../../foundation/Utility";
type ToolbarEntries =
    | React.ReactElement<ToolbarButton>
    | React.ReactElement<ToolbarText>;

interface ToolbarProps {
    className?: string;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    position?: Side;

    bondTop?: boolean;
    direction?: RenderOrientationFlow;

    children?: ToolbarEntries[] | ToolbarEntries;
}

interface ToolbarState {}

class Toolbar extends React.Component<ToolbarProps, ToolbarState> {
    render(): React.ReactNode {
        let classNames = this.props.className
            ? `toolbar ${this.props.className}`
            : "toolbar";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        switch (this.props.position) {
            case Side.Bottom:
                classNames += " bottom";
                break;
            case Side.Left:
                classNames += " left";
                break;
            case Side.Right:
                classNames += " right";
                break;
        }

        switch (this.props.direction) {
            case RenderOrientations.RightLeft:
                classNames += " flex-row-reverse";
                break;
            default:
                classNames += " flex-row";
                break;
        }

        return <div className={classNames}>{this.props.children}</div>;
    }
}

export default Toolbar;
